import * as React from "react";
const SvgIconDropdownArrow = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", width: 18, height: 10, viewBox: "0 0 18 10", ...props }, /* @__PURE__ */ React.createElement("title", null, "arrowicon"), /* @__PURE__ */ React.createElement("polygon", { points: "0 0 18 0 9 10 0 0", style: {
  fill: "#277575"
} }));
export { SvgIconDropdownArrow as ReactComponent };
